module.exports = __webpack_public_path__ + "static/media/icon-youtube.a51ab7ed.svg";